'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Accordion, { accordionClasses, } from '@enlighten/design-system/dist/Accordion';
import AccordionDetails from '@enlighten/design-system/dist/AccordionDetails';
import AccordionSummary, { accordionSummaryClasses, } from '@enlighten/design-system/dist/AccordionSummary';
import Grid from '@enlighten/design-system/dist/Grid';
import { useTheme } from '@enlighten/design-system/dist/styles';
import Typography from '@enlighten/design-system/dist/Typography';
import useMediaQuery from '@enlighten/design-system/dist/useMediaQuery';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
const list = [
    {
        title: '구독 상품이란 무엇인가요?',
        content: `전기요금 절감 목적으로 설치하는 자가소비형 태양광 설치비에 대해,
		일시납 또는 분납 형태로 지불하고 구독 서비스를 받아보실 수 있는 상품입니다. 
		렌탈 상품과는 다르게 태양광 설비의 소유권이 설치 완료 시점부터 고객에게 있습니다.`,
    },
    {
        title: '태양광 설치하면 얼마나 사용 가능한가요?',
        content: `태양광은 한 번 설치하게 되면 20년 이상 사용이 가능합니다. 일반적으로 모듈 제조사는 
		출력에 대해 25년간의 보증을 제공하고 있으며, 인버터 제조사는 5년간의 보증을 제공하고 있습니다. 
		엔라이튼 구독 상품의 경우, 3년 간의 하자 보증 기간이 지나더라도 유상 A/S를 통해 구독 기간 내 설비 하자에 대한 관리를 진행하고 있습니다.
		`,
    },
    {
        title: '설치에 필요한 면적은 어떻게 되나요?',
        content: `가로 3.5m x 세로 4m의 공간 혹은 가로 6.5m x 세로 2m 의 공간에 설치가 가능합니다. *모듈 기준 
		하지만 주택마다 옥상의 모양 및 구조가 다르기 때문에 장소에 따라 패널 설치 방식을 달리할 수도 있으므로
		자세한 내용은 상담이 필요합니다.`,
    },
    {
        title: '공사는 언제, 얼마나 걸리나요?',
        content: `일반적으로 공사는 반나절 정도 소요되며, 
		시작 일자는 업무 상황에 따라 변동될 수 있어 담당 부서와 별도 협의가 필요합니다.`,
    },
    {
        title: '절감된 전기요금은 어떻게 확인하나요?',
        content: `태양광 설비를 통해 생산된 발전량만큼 전기요금 고지서에 상계되어 청구됩니다. `,
    },
    {
        title: '구독 기간(7년)이 지나면 어떻게 되나요?',
        content: `구독 기간이 끝나게 되면 별도의 구독료 지불 없이 전기요금 절감 혜택을 누리실 수 있습니다.`,
    },
    {
        title: '고장 나면 어떻게 하나요?',
        content: `주택용 태양광 고객센터(02-6231-1426)로 연락 주시면 고장 유형에 따른 방법 안내해 드리겠습니다.`,
    },
    {
        title: '구독료가 왜 변경될 수 있는건가요?',
        content: `주택용 태양광 구독 상품은 초기 설치비 부담을 줄여드리기 위해 엔라이튼이 금융기관과 함께 설계한 상품입니다. 
		금융기관이 선 투자하고 고객님은 장기간 구독료를 통해 납부하는 방법으로 금리에 연동되도록 설계되었습니다.
		* 구독 상품은 '대출'이 아니며 따라서 주택용 태양광 구독 시 고객님의 신용에 미치는 영향은 없습니다.`,
    },
    {
        title: '구독을 해지하고 싶으면 어떻게 하나요?',
        content: `구독 해지는 언제든지 가능합니다. 해지 신청 후 잔여금액에 대한 상환이 필요합니다. 
*중도상환수수료가 잔여금액의 1% 수준으로 발생합니다.`,
    },
];
export default function HouseSection5() {
    const [accordionIndex, setAccordionIndex] = useState();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (_jsxs(Grid, { container: true, direction: "column", alignItems: { xs: 'center', md: 'flex-start' }, maxWidth: 1440, marginX: "auto", padding: { xs: '60px 24px', md: '100px 16px 140px' }, children: [_jsx(Typography, { fontSize: { xs: 24, md: 40 }, fontWeight: 700, marginBottom: { xs: '30px', md: '100px' }, children: "\uC790\uC8FC \uBB3B\uB294 \uC9C8\uBB38" }), _jsx(Grid, { container: true, direction: "column", gap: { xs: '10px', md: '20px' }, children: list.map(({ title, content }, i) => isMobile ? (_jsxs(Grid, { border: (theme) => `1px solid ${theme.palette.grey['300']}`, borderRadius: "10px", padding: "20px", boxShadow: "0 4px 10px #0000000D", children: [_jsx(Typography, { fontSize: 16, fontWeight: 700, children: title }), _jsx(Typography, { fontSize: 14, lineHeight: 1.5, marginTop: "10px", children: content })] }, i)) : (_jsxs(Accordion, { expanded: accordionIndex === i, onChange: () => {
                        setAccordionIndex((index) => {
                            if (index == null || index !== i) {
                                return i;
                            }
                            return undefined;
                        });
                    }, sx: {
                        bgcolor: 'grey.200',
                        borderRadius: '20px',
                        margin: 0,
                        padding: '50px 40px',
                        boxShadow: 'none',
                        transition: 'box-shadow 0.3s ease',
                        ':first-of-type, :last-of-type': {
                            borderRadius: '20px',
                        },
                        '::before': {
                            display: 'none',
                        },
                        [`&.${accordionClasses.expanded}`]: {
                            bgcolor: '#F9FAFF',
                            border: '2px solid #E3D3FB',
                            padding: '48px 38px',
                            margin: 0,
                            boxShadow: '0 4px 4px #00000040',
                        },
                    }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMore, { fontSize: "large" }), sx: {
                                [`&, &.${accordionSummaryClasses.expanded}`]: {
                                    minHeight: 44,
                                },
                                [`.${accordionSummaryClasses.content}`]: {
                                    justifyContent: 'left',
                                    fontSize: 28,
                                    fontWeight: 700,
                                    height: '100%',
                                    margin: 0,
                                },
                            }, children: title }), _jsx(AccordionDetails, { sx: {
                                fontSize: 20,
                                lineHeight: 1.5,
                                whiteSpace: 'pre-line',
                                padding: '30px 0 0 0',
                            }, children: content })] }, i))) })] }));
}
